import gateway from '../gateway/gateway'
import { User } from '../types/user'

export const getPersonByEmail = async (
  email: string,
  currentUser?: Pick<User, 'user_guid' | 'features'>
) => {
  if (currentUser?.features.outlook_public_api_people) {
    const query = {
      email_addresses: [email],
      sort_by: 'last_contacted_at',
    }

    const people = await gateway.publicPeople.get({
      ...query,
      owned_by_guid: currentUser.user_guid,
    })

    if (people.length === 0) {
      return gateway.publicPeople.get(query)
    }

    return people
  }

  return gateway.people.findByEmail(email)
}
